
<template>
	<div class="instrument-details">
		<div class="head">
			<img :src="instrument_details.banner" alt="">
			<div class="name">
				<span>{{instrument_details.name}}</span>
				<div class="time">
					<p>{{instrument_details.created_at}}</p>
				</div>
			</div>
		</div>
		<div class="hr-7"></div>
		<div class="content">
			<van-tabs v-model="active" color="#901d22">
	  			<van-tab title="简介">
	  				<div class="brief">
		  				<div>
		  					<h4>品牌</h4>
		  					<p v-if="instrument_details.brand">{{instrument_details.brand.name}}</p>
		  				</div>
		  				<div>
		  					<h4>名称</h4>
		  					<p>{{instrument_details.name}}</p>
		  				</div>
		  				<div>
		  					<h4>简介</h4>
							  <!-- {{instrument_details.content}} -->
		  					<p v-html="instrument_details.content"></p>
		  				</div>
		  				<div>
		  					<h4>相关图片</h4>
		  					<img :src="item.url" alt="" v-for="(item,index) in instrument_details.photos" :key="index">
		  				</div>
	  				</div>
	  			</van-tab>
	  			<van-tab title="型号">
	  				<div class="model" v-for="(item) in instrument_model" :key="item.id">
	  					<table  border="1px" cellspacing="0px" cellpadding="0px"  style="border-collapse:collapse;" bordercolor="#BFBFBF" align="center"  :width="tableWidth">
	  						<tr height="40px" >
	  							<template v-for="value in item.table[0]">
	  								<th>{{value}}</th>
	  							</template>
	  						</tr>
	  						<template v-for="(value,index) in item.table">
		  						<tr height="30px" v-if="index>0">
									<template v-for="val in value">
										<td >{{val}}</td>
									</template>
		  						</tr>
	  						</template>
	  					</table>
						  <img :src="item.image" alt="">
	  				</div>
	  			</van-tab>
	  			<van-tab title="病例">
	  				<div class="cases">
		  				<div class="nullStatus" v-if="instrument_cases.length<=0">
		  					<img src="../../assets/images/case-null.png" alt="">
		  					<p>暂无病例信息</p>
		  				</div>
		  				<div class="list">
		  					<column-item-list :columnList="instrument_cases"></column-item-list>
		  				</div>
	  				</div>
	  			</van-tab>
	  		    <van-tab title="评测">
					  <row-item-list :list="evaluatesList"></row-item-list>
		  				<div class="nullStatus" v-if="evaluatesList.length<=0">
		  					<img src="../../assets/images/case-null.png" alt="">
		  					<p>暂无评测信息</p>
		  				</div>
				  </van-tab>
			</van-tabs>
		</div>
	</div>
</template>
<script>
	import ColumnItemList from "../../components/ColumnItemList";
	import RowItemList from '@/components/RowItemList';
	import {ColumnList,InstrumentDetails,InstrumentTables,InstrumentCases,InstrumentEvaluates} from "../../config/interface.js"
	export default{
		components:{
			ColumnItemList,
			RowItemList
		},
		data(){
			return{
				active:0,
				instrument_id:0,   	//器械id
				columnList:[],    	//专栏列表 1
				instrument_details:{},   //器械详情
				instrument_model:[],     //器械型号
				instrument_cases:[],     //器械病例
				evaluatesList:[],		//器械评测
				tableWidth:0,			//表格宽度
			}
		},
		created(){

		},
		mounted(){
			this.instrument_id=this.$route.query.id;
			this.getColumns();
			this.instrumentDetails();
			this.instrumentTables();
			this.instrumentCases();
			this.instrumentEvaluates();

		},
		methods:{
			//器械详情
			instrumentDetails(){
				const url=InstrumentDetails;
				let params={
					instrument_id:this.instrument_id
				};
				const  method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						if(common.is_weixin()){
							common.wxShare(data.share_title,data.share_sub_title,data.share_img)
						}
						console.log(data);
						this.instrument_details=data;
					}
				})

			},
			//器械型号
			instrumentTables(){
				const url=InstrumentTables;
				let params={
					instrument_id:this.instrument_id
				};
				const  method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.instrument_model=data;
						if(data.length>0){
							this.tableWidth=data[0].table[0].length*100+'px'
						}
						// data.forEach((item,index)=>{
						// 	let keys=Object.values(data[index].table[0]);

						// })
						// for(let i=0;i++;i<data.length){
						// 	let keys=Object.values(data[i].table[0]);
						// 	 for(let j=1;j++;j<data[i].table.length){
						// 		 for(let m=0;m++;m<data[i].table[j].length){
						// 			 let obj={
										  
						// 			 };
									
						// 		 }
						// 	 }
						// }
						// console.log(data[0].table[0]);
						
						// console.log(keys)
						// this.instrument_model=data;

					}
				})
			},
			//器械病例
			instrumentCases(){
				const url=InstrumentCases;
				let params={
					instrument_id:this.instrument_id
				};
				const  method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.instrument_cases=data;

					}
				})
			},
			//器械评测
			instrumentEvaluates(){
				const url=InstrumentEvaluates;
				let params={
					instrument_id:this.instrument_id
				};
				const  method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.evaluatesList=data;
					}
				})
			},
			//专栏列表
			getColumns(){
				const url=ColumnList;
				const method='POST';
				let params={
					limit:6,
					page:1
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						let follows=data.follows;
						this.columnList=data.columns.data;
						this.columnList.forEach(function(item,index){
							item.follow_total=follows[item.id];
						})
					}
				})
			},
		}
	}
</script>
<style lang="scss">
	.instrument-details{
		.head{
			img{
				width:100%;
				height:165px;
			}
			.name{
				padding:14px 12px;
				/*border-bottom:1px solid #f1f1f1;*/
				span{
					font-size:15px;
					color:#090909;
					letter-spacing: 0.53px;
				}
				.time{
					margin-top: 10px;
					@include flex(row);
					justify-content:space-between;
					p{
						color:#666;
					}
					.attention{
						border: 1px solid #D3D3D3;
						border-radius: 1px;
						height:20px;
						line-height:20px;
						padding:0 7px;
						font-size: 10px;
						color: #090909;
						letter-spacing: 0.35px;
					}
				}
			}
		}
		.content{
			width:100%;
			position:absolute;
			top:277px;
			bottom:0px;
			left:0;
			.van-tabs--line{
				width:100%;
				height:100%;
			}
			.nullStatus{
				position:absolute;
				top:50%;
				left:50%;
				transform:translate(-50%,-50%);
				text-align:center;
				img{
					width:180px;
				}
				p{
					font-size: 13px;
					color: #999999;
					letter-spacing: 0.46px;
				}
			}
			/*简介*/
			.brief{
				padding:14px 12px;
				div{
					padding:5px 0px;
					h4{
						font-size: 14px;
						color: #090909;
						letter-spacing: 0.12px;
						margin-bottom:10px;
					}
					span{
						font-size: 12px;
						color: #666666;
						letter-spacing: 0.42px;
					}
					img{
						display:block;
						width:284px;
						margin:0px auto;
						margin-bottom:5px;
					}
				}
			}
			/*型号*/
			.model{
				width:95%;
				overflow: auto;
				margin:10px auto;
				box-shadow:1px 2px 2px #ddd;
				td{
					text-align:center;
					font-size: 13px;
					color: #333;
					letter-spacing: 0.1px;
				}
				th{
					font-size:14px;
					background-color:#FFEFF0;
				}
				img{
					margin-top:20px;
				}
			}
			/*病例*/
			.cases{
				.list{
					padding:14px 12px;
				}
			}

		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/Instrument/details.vue